/** Per-kind config for bond-retrieval basic information steps (Phase 9.9G). */

import { BOND_BASIC_INFO_CONFIG } from "./bondBasicInformationConfig";

const RETRIEVAL_SURFACE_OVERLAY = {
  surface: "retrieval",
  supportsLayoutView: false,
  splitByRepresentatives: false,
  showCourtCaseToggle: false,
  showJudgeSternWarning: false,
  esignatureMode: "always",
  hydrateStorageOnMount: true,
};

export const RETRIEVAL_BASIC_INFO_CONFIG = {
  probate: {
    ...BOND_BASIC_INFO_CONFIG.probate,
    ...RETRIEVAL_SURFACE_OVERLAY,
    judgeSternLabel: "Has the Judge issued his order requiring bond yet?",
  },
  trustee: {
    ...BOND_BASIC_INFO_CONFIG.trustee,
    ...RETRIEVAL_SURFACE_OVERLAY,
  },
  va: {
    ...BOND_BASIC_INFO_CONFIG.va,
    ...RETRIEVAL_SURFACE_OVERLAY,
    courtCaseRequired: true,
  },
  guardianship: {
    ...BOND_BASIC_INFO_CONFIG.guardianship,
    ...RETRIEVAL_SURFACE_OVERLAY,
    countiesFetchMode: "all",
    fieldOrder: "guardianship",
    parseGuardianshipBondAmount: true,
    principalInputType: "text",
    bondSubCategoryRequired: false,
  },
};
